import { useAuth } from "@luce/core/auth";

/** The signed-in account id, surfaced under this app's domain term (the client). */
export function useClientId(): string {
  return useAuth().accountId;
}
